module.exports = __webpack_public_path__ + "img/logo-ct-white.fcefbb52.png";